<template>
  <div
    class="modal nb-modal-mask"
    style="display:block; z-index: 1 !important;"
    @keydown.esc="closeModal"
  >
  <Trap>

    <div class="modal-dialog modal-dialog-centered modal-md" role="document" style="overflow-y: initial !important">
      <div class="modal-content">
        <div class="modal-body pt-3" style="max-height: 100%; overflow-y: auto;">
          <div class="lbl mb-2" style="font-size: 20px">
            <strong>Selecione um Documento</strong>
          </div>
          <button @click="closeModal" class="close">
            <span>&times;</span>
          </button>
          <div class="main-content">
            <div class="row">
              <div class="col-12 mb-3">
                <select ref="list" 
                    class="form-control" multiple size="6" 
                    style="font-size: 24px"
                    :value="selectedOption" 
                    @change="handleSelect"
                    @keydown.enter="handleEmit">
                  <option value="NC">Emitir NFc-e</option>
                  <option value="NF">Emitir NF-e</option>
                  <option value="CP">Emitir Cupom Não Fiscal</option>
                  <option value="FV">Finalizar Venda</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </Trap>
  </div>
</template>

<script>
import Trap from "vue-focus-lock";

export default {
  components: {
    Trap,
  },

  props: {
    params_pdv: {
      type: Object,
      default: () => ({ colors: {} })
    },
  },
  
  data() {
    return {
      selectedOption: null,
    };
  },
  
  computed: {

  },

  methods: {
    
    handleEmit() {
      this.$emit('selected', this.selectedOption)
    },

    handleSelect(evt) {
      this.selectedOption = evt.target.value;
    },

    closeModal(event) {
      this.$emit("closeModal", event);
    }
  },

  mounted() {
    this.$nextTick(function() {
        this.$refs.list.focus();
      });
  },

  beforeDestroy() {
  }

};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-modal-opcoes-final.vue